import { render, staticRenderFns } from "./ModalBrokerLogs.vue?vue&type=template&id=df91b788&scoped=true&"
import script from "./ModalBrokerLogs.vue?vue&type=script&lang=js&"
export * from "./ModalBrokerLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df91b788",
  null
  
)

export default component.exports